import { render, staticRenderFns } from "./SignDoc.vue?vue&type=template&id=5bfe2743&scoped=true&lang=pug&"
import script from "./SignDoc.vue?vue&type=script&lang=js&"
export * from "./SignDoc.vue?vue&type=script&lang=js&"
import style0 from "./SignDoc.vue?vue&type=style&index=0&id=5bfe2743&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe2743",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
